import React from "react";
import classes from "./Industries.module.scss";
import { useTranslation } from "react-i18next";
const erpImage = require("../../../media/software-development/industries/erp.png");
const crmImage = require("../../../media/software-development/industries/crm.png");
const bimImage = require("../../../media/software-development/industries/bim.png");
const wmsImage = require("../../../media/software-development/industries/wms.png");
const ehrImage = require("../../../media/software-development/industries/ehr.png");
const utilityImage = require("../../../media/software-development/industries/utility.png");
const gisImage = require("../../../media/software-development/industries/gis.png");
const riskImage = require("../../../media/software-development/industries/risk.png");
const pacsImage = require("../../../media/software-development/industries/pacs.png");
const pacs2Image = require("../../../media/software-development/industries/pacs-2.png");
const facilityImage = require("../../../media/software-development/industries/facility.png");
const analyticsImage = require("../../../media/software-development/industries/analytics.png");
const edmsImage = require("../../../media/software-development/industries/edms.png");
const tmsImage = require("../../../media/software-development/industries/tms.png");

const Industries = ({ title, subtitle }) => {
  const { t } = useTranslation();
  
  const images = [
    { image: erpImage, id: 1, text: t('industries.0.text') },
    { image: crmImage, id: 2, text: t('industries.1.text') },
    { image: bimImage, id: 3, text: t('industries.2.text') },
    { image: wmsImage, id: 4, text: t('industries.3.text') },
    { image: ehrImage, id: 5, text: t('industries.4.text') },
    { image: utilityImage, id: 6, text: t('industries.5.text') },
    { image: gisImage, id: 7, text: t('industries.6.text') },
    { image: riskImage, id: 8, text: t('industries.7.text') },
    { image: pacsImage, id: 9, text: t('industries.8.text') },
    { image: pacs2Image, id: 10, text: t('industries.9.text') },
    { image: facilityImage, id: 11, text: t('industries.10.text') },
    { image: analyticsImage, id: 12, text: t('industries.11.text') },
    { image: edmsImage, id: 13, text: t('industries.12.text') },
    { image: tmsImage, id: 14, text: t('industries.13.text') },
  ];  
  
  return (
    <section className={classes.section}>
      <h2 className={classes.header}>{title}</h2>
      <p className={classes.text}>{subtitle}</p>

      <div className={classes["images-block"]}>
        {images.map(({ image, id, text }) => (
          <div key={id} className={classes["image-container"]}>
            <img src={image} alt={text} />
            <span className={classes.text}>{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Industries;
